<template>
  <div id="wrapper">
    <SidebarView :budgets="true" :budgetsCreate="true" />
    <div class="d-flex flex-column" id="content-wrapper">
      <div id="content">
        <TopbarView />
        <div class="container">
          <div class="card card-shape home-box">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col-12">
                  <h6 class="m-0 fw-bold text-green">Create Budget</h6>
                </div>
              </div>
            </div>
            <div class="card-body">
              <b-alert v-if="noAccess" show variant="danger">
                Access Denied! You do not have the necessary permissions to view this page.
              </b-alert>

              <div v-else>
                <b-alert v-if="!canManage" show variant="danger">
                  No access: you do not have permission to create budgets.
                </b-alert>

                <div v-else class="row g-3">
                <div class="col-md-6">
                  <label class="form-label small fw-bold">Name</label>
                  <input v-model="form.name" class="form-control form-control-sm" />
                </div>
                <div class="col-md-4">
                  <label class="form-label small fw-bold">Financial Year</label>
                  <select v-model="form.financial_year_id" class="form-select form-select-sm">
                    <option value="">Select financial year</option>
                    <option v-for="fy in financialYears" :key="fy.id" :value="String(fy.id)">
                      {{ fy.start_date }} → {{ fy.end_date }} ({{ fy.status }})
                    </option>
                  </select>
                </div>
                <div class="col-12">
                  <b-button class="btn akkurate-green-btn text-white btn-size" :disabled="isSaving" @click="createBudget">
                    {{ isSaving ? "Saving..." : "Create" }}
                  </b-button>
                  <a href="/budgets" class="btn akkurate-gray-btn text-white btn-size ms-2">Back</a>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer></footer>
    </div>
    <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
  </div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import ApiService from "@/core/services/api.service";
import { hasPermission } from "@/helper";

export default {
  name: "BudgetCreate",
  components: { SidebarView, TopbarView },
  data() {
    return {
      isSaving: false,
      noAccess: false,
      financialYears: [],
      form: {
        name: "",
        financial_year_id: "",
      },
    };
  },
  computed: {
    canManage() {
      return hasPermission("budgets_manage");
    },
  },
  created() {
    this.loadFinancialYears();
  },
  methods: {
    async createBudget() {
      if (!this.canManage) return;
      this.isSaving = true;
      this.noAccess = false;
      try {
        const res = await ApiService.post("/budgets", this.form);
        const id = res.data?.data?.id ?? res.data?.id;
        if (id) {
          window.location.href = `/budgets/${id}`;
        } else {
          window.location.href = "/budgets";
        }
      } catch (e) {
        if (e?.response?.status === 403) this.noAccess = true;
      } finally {
        this.isSaving = false;
      }
    },
    async loadFinancialYears() {
      try {
        const res = await ApiService.get("/setup/financial-years/all");
        this.financialYears = res.data?.data || [];
      } catch (e) {
        this.financialYears = [];
      }
    },
  },
};
</script>

